var DEFAULT_LANGUAGE = 'en';
export default function getBrowserLang() {
  if (window.navigator && window.navigator.language) {
    var lang = window.navigator.languages ? window.navigator.languages[0] : window.navigator.language;
    return lang.slice(0, 2);
  } else {
    return DEFAULT_LANGUAGE;
  }
}